import {
  getGetBrandsBrandIdChannelsMineUrl,
  getGetChannelsSourceHandlesSourceChannelHandleUrl,
  getGetChannelsSourceSourceChannelIdInfoUrl,
  getPatchBrandsBrandIdRefreshAudienceStatsUrl,
  getPostCompetitorsPublicUrl,
  getPutBrandsBrandIdPublicVideosSourceVideoIdUrl,
} from '@dashhudson/api-client/youtube/client';
import merge from 'lodash/merge';

import { createDashHttpClient } from '@/apis/dash.http';
import { env } from '@/env';
import { toUtcQueryDateTime } from '@/utils';

export const http = createDashHttpClient(env.youtubeApiUrl);
export const camelCaseHttp = createDashHttpClient(env.youtubeApiUrl, {
  camelizeKeys: true,
});

export async function getYouTubeChannel({ brandId }, config = {}) {
  return camelCaseHttp.get(getGetBrandsBrandIdChannelsMineUrl(brandId), config);
}

export async function getTrendingVideos({ brandId, startDate, endDate, limit }, config = {}) {
  return http.get(
    `/brands/${brandId}/videos/trending`,
    merge(
      {
        params: {
          startDate: toUtcQueryDateTime(startDate),
          endDate: toUtcQueryDateTime(endDate),
          limit,
        },
      },
      config,
    ),
  );
}

export async function getPublicAccountsByIds({ sourceChannelIds }, config = {}) {
  return camelCaseHttp.post(getPostCompetitorsPublicUrl(), { sourceChannelIds }, config);
}

export async function getYouTubeRefreshAudienceStats(brandId, sourceVideoId, config = {}) {
  return http.patch(
    getPatchBrandsBrandIdRefreshAudienceStatsUrl(brandId),
    {
      video_id: sourceVideoId,
    },
    config,
  );
}

export async function getYouTubeFeedVideos({ handle, limit, nextToken }, config = {}) {
  return camelCaseHttp.get(
    getGetChannelsSourceHandlesSourceChannelHandleUrl(handle),
    merge(
      {
        params: {
          includeUploads: true,
          uploadsPageSize: limit,
          uploadsPageToken: nextToken,
        },
      },
      config,
    ),
  );
}

export async function getYouTubeChannelInfoBySourceId({ sourceChannelId }, config = {}) {
  return camelCaseHttp.get(getGetChannelsSourceSourceChannelIdInfoUrl(sourceChannelId), config);
}

export async function createMediaForVideo({ brandId, sourceVideoId }, config = {}) {
  return camelCaseHttp.put(
    getPutBrandsBrandIdPublicVideosSourceVideoIdUrl(brandId, sourceVideoId),
    {},
    config,
  );
}
